// extracted by mini-css-extract-plugin
module.exports = {"slider":"_02712f2b3b--slider--NLyUe"};